// src/i18n/en/channels.ts
// English mirror of es/channels.ts — see that file for the rationale.
export const channels = {
  online: 'Online pre-check-in',
  kiosk: 'Kiosk',
  airLobby: 'Air Lobby',
  mobileKiosk: 'Mobile kiosk',
  dispenser: 'Key dispenser',
  none: 'No channel',

  short: {
    online: 'Online',
    kiosk: 'Kiosk',
    airLobby: 'Air Lobby',
    mobileKiosk: 'Mobile',
    dispenser: 'Dispenser',
  },
};

export default channels;
